import { render, staticRenderFns } from "./MouseBalls.vue?vue&type=template&id=532e87fc&"
import script from "./MouseBalls.vue?vue&type=script&lang=js&"
export * from "./MouseBalls.vue?vue&type=script&lang=js&"
import style0 from "./MouseBalls.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports